<template>
    <div class="modal-body">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-1">
            <label class="form-label">Title</label>
            <div class="input-group input-group-merge w-100">
              <input
                  name="name"
                  type="text"
                  class="form-control"
                  placeholder="Enter Title"
                  v-model="formData.title"
              />
            </div>
        </div>

        <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-1">
            <label class="form-label">Date & Time</label>
            <div class="row">
                <div class="col-sm-12 col-lg-6">
                    <label class="form-label">From</label>
                    <input
                        v-model="formData.start_time"
                        name="datetime"
                        type="datetime-local"
                        class="form-control"
                        placeholder="Enter Start date"
                    />
                </div>
                <div class="col-sm-12 col-lg-6">
                    <label class="form-label">To</label>
                    <input
                        v-model="formData.end_time"
                        name="datetime"
                        type="datetime-local"
                        class="form-control"
                        placeholder="Enter End date"
                    />
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-6 col-sm-6 col-md-6 col-lg-6 mb-1">
                <label class="form-label">Assign To</label>
                <AsyncSelect
                    placeholder="Assign To"
                    :disabled="isCreator"
                    v-model="formData.assign_to"
                    :api-service="fetchContactProfiles"
                    :additional-query="{roles: 'employee'}"
                    label="name"
                />
            </div>
            <div class="col-6 col-sm-6 col-md-6 col-lg-6 mb-1">
                <label class="form-label">Report To</label>
                <AsyncSelect
                    placeholder="Report To"
                    :disabled="isCreator"
                    v-model="formData.report_to"
                    :api-service="fetchContactProfiles"
                    :additional-query="{roles: 'employee'}"
                    label="name"
                />
            </div>
        </div>

        <div class="col-6 col-sm-6 col-md-6 col-lg-6 mb-1">
            <label for="colFormLabel" class="col-form-label">Participants </label>
            <AsyncSelect
                multiple
                placeholder="Select participants"
                v-model="formData.participants"
                :disabled="isParticipant"
                :api-service="fetchContactProfiles"
                :additional-query="{roles: 'employee'}"
                label="name"
            />
        </div>

      <div class="row justify-content-end">
        <div class="col-4 btn-margin text-right">
          <button class="btn btn-outline-primary" @click="isMoreSelected = !isMoreSelected">
            {{ isMoreSelected ? 'Less Options' : 'More Options' }}
          </button>
        </div>
      </div>

      <div v-if="isMoreSelected">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-1">
          <label class="form-label">Organization Activity</label>
          <AsyncSelect
              multiple
              placeholder="Select Activity"
              v-model="formData.or_activity"
              :disabled="isParticipant"
              :api-service="fetchActivitySetupEndpoint"
              label="name"
          />
        </div>

        <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-1">
          <label class="form-label">Client</label>
          <AsyncSelect
              placeholder="Client"
              v-model="formData.client"
              :disabled="isParticipant"
              :api-service="fetchContactProfiles"
              :additional-query="{roles: 'customer,lead'}"
              label="name"
          />
        </div>

        <div class="row">
          <div class="col-6 col-sm-6 col-md-6 col-lg-6 mb-1">
            <label class="form-label">Project</label>
            <v-select
                placeholder="Select Project"
                v-model="formData.project"
                :options="projects"
                :disabled="isParticipant"
                label="name"
                @option:selected="onChangeSelectedProject"
            />
          </div>
          <div class="col-6 col-sm-6 col-md-6 col-lg-6 mb-1">
            <label class="form-label">Project Activity</label>
            <AsyncSelect
                placeholder="Select Project Activity"
                v-model="formData.project_activity"
                :api-service="fetchProjectActivity"
                :disabled="isParticipant"
                ref="projectActivityDropdown"
                label="name"
                :additional-query="{ project_id: formData.project && formData.project.id }"
            />
          </div>
        </div>

        <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-1">
          <label class="form-label">Tag</label>
          <v-select
              multiple
              placeholder="Select Tag"
              v-model="formData.tag"
              :disabled="isParticipant"
              :options="tagList"
              label="name"
          />
        </div>

        <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-1">
          <label class="form-label">Priority</label>
          <v-select
              placeholder="Select Priority"
              v-model="formData.priority"
              :disabled="isParticipant"
              :options="priorityList"
              label="name"
          />
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-1">
        <label class="form-label">Location / Mode</label>
          <AsyncSelect
              placeholder="Select Location"
              v-model="formData.area_id"
              :disabled="isParticipant"
              :api-service="fetchAreaList"
              label="name"
          />
        </div>

        <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-1">
          <label class="form-label">Description</label>
          <div class="input-group input-group-merge w-100">
                    <textarea
                        v-model="formData.description"
                        :disabled="isParticipant"
                        name="reference" rows="2"
                        placeholder="Enter Description"
                        class="form-control add-credit-card-mask"
                    >
                    </textarea>
          </div>
        </div>

        <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-1">
          <label class="form-label">Attachment</label>
          <BlobFileViewer :attachments="formData.attachments" />
          <FileUpload
              :is-drag-active="true"
              button-text="Upload Documents"
              v-model="formData.attachments"
          >
          </FileUpload>
        </div>
      </div>

      <div v-if="markAsDoneShow && !isParticipant">
        <hr>
        <h4 class="fw-bolder">Completion</h4>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-8 mb-1">
            <label class="form-label">Location</label>
            <AsyncSelect
                placeholder="Select Location"
                :disabled="isMarkDoneForm"
                v-model="markDoneFormData.area_id"
                :api-service="fetchAreaList"
                :additional-query="{with_amount: 1}"
                label="label"
            />
          </div>

          <div class="col-12 col-sm-12 col-md-4 mb-1">
            <label class="form-label">Input Hours</label>
            <input
                name="name"
                :disabled="isMarkDoneForm"
                type="text"
                class="form-control"
                placeholder="Enter Hours"
                v-model="markDoneFormData.hours"
            />
          </div>
        </div>
      </div>
    </div>
</template>

<script setup>
import {ref, reactive, onMounted} from 'vue';
import { getCurrentDateTime } from '@/services/utils/global.js';
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import handleContact from '@/services/modules/contact'
import handleDropDowns from '@/services/modules/dropdowns'
import {useRoute} from "vue-router";
import FileUpload from "@/components/atom/FileUpload";
import BlobFileViewer from "@/components/atom/BlobFileViewer";
import handleProjects from "@/services/modules/procurement/project";
import handleCrm from '@/services/modules/crm/crm'

const {fetchContactProfiles} = handleContact()
const { fetchActivitySetupEndpoint } = handleDropDowns();
const {fetchProjectActivity} = handleProjects();
const { fetchAreaList } = handleCrm();

const props = defineProps({
    startDate: String,
    endDate: String,
    tagList: Array,
    priorityList: Array,
    editData: {
      type:Object,
      default: {}
    },
    taskStatus: {
      type:Object,
      default: {}
    },
    markAsDoneShow:{
      type:Boolean,
      default: false
    },
    isCompleted:{
      type:Boolean,
      default: false
    },
    projects: Array,
});

const route = useRoute();

const markDoneFormData = reactive({
  id:null,
  area_id: null,
  hours: null,
})

const formData = reactive({
    type: 'event',
    assign_to: null,
    report_to: null,
    area_id: null,
    or_activity: [],
    client: null,
    project: null,
    project_activity: null,
    tag: [],
    priority: null,
    start_time: getCurrentDateTime(props.startDate),
    end_time: getCurrentDateTime(props.endDate),
    title: '',
    description: '',
    attachments: [],
    participants: [],
    route_name:'task-calendar'
});

const isMoreSelected = ref(false);
const isCreator = ref(false);
const isParticipant = ref(false);
const isMarkDoneForm = ref(false);

const resetForm = () => {
  formData.title = '';
  formData.start_time = null
  formData.end_time = null
  formData.description = '';
  formData.assign_to = null;
  formData.area_id = null;
  formData.report_to = null;
  formData.client = null;
  formData.project = null;
  formData.project_activity = null;
  formData.priority = null;
  formData.participants = [];
  formData.or_activity = [];
  formData.tag = [];
  formData.attachments = [];
  markDoneFormData.area_id = null;
  markDoneFormData.hours = null;
};

function getFormData() {
  return {...formData};
}

function getMarkDoneFormData() {
  return {...markDoneFormData};
}

onMounted(() => {
  if (props.editData && Object.keys(props.editData).length) {
    const valuesMap = {};

    props.editData.values &&  props.editData.values.forEach((val) => {
      const obj = val.field_value
          ? {
            ...val.field_value,
            id: val.field_value_id,
            name: val.field_value.full_name || val.field_value.name || '',
          }
          : null;

      if (['participant_id', 'activity_setup_id', 'tag_id'].includes(val.field_key)) {
        if (!valuesMap[val.field_key]) valuesMap[val.field_key] = [];
        if (obj) valuesMap[val.field_key].push(obj);
      }
      if (!['participant_id', 'activity_setup_id', 'tag_id'].includes(val.field_key)) {
        valuesMap[val.field_key] = obj;
      }
    });

    markDoneFormData.id = props.editData.id;
    markDoneFormData.area_id = {
      id: props.editData.area_id,
      label: props.editData.area_label
    };
    markDoneFormData.hours = props.editData.hours;

    formData.id = props.editData.id
    formData.title = props.editData.short_description || '';
    formData.start_time = props.editData.start_time || getCurrentDateTime(props.startDate);
    formData.end_time = props.editData.end_time || getCurrentDateTime(props.endDate);
    formData.description = props.editData.full_description || '';
    formData.type = props.editData.type || '';
    formData.assign_to = valuesMap['assigned_to'] || null;
    formData.report_to = valuesMap['report_to'] || null;
    formData.client = valuesMap['client_id'] || null;
    formData.project = valuesMap['project_id'] || null;
    formData.project_activity = valuesMap['project_activity_id'] || null;
    formData.priority = valuesMap['priority_id'] || null;
    formData.area_id = valuesMap['area_id'] || null;
    formData.participants = valuesMap['participant_id'] || [];
    formData.or_activity = valuesMap['activity_setup_id'] || [];
    formData.tag = valuesMap['tag_id'] || [];
    formData.attachments = props.editData.attachments || [];
  }

  if (props.taskStatus && props.taskStatus.is_created != 1 && Object.keys(props.taskStatus).length !== 0){
    isCreator.value = true;
  }
  if (props.taskStatus && props.taskStatus.participant && Object.keys(props.taskStatus).length !== 0){
    isParticipant.value = true;
  }
  if (props.isCompleted && !props.taskStatus.report_to){
    isMarkDoneForm.value = true;
  }
});

defineExpose({
  getFormData,
  getMarkDoneFormData,
  resetForm
});

</script>

<style scoped> 
.btn-margin {
    margin-right: 20px;
    margin-bottom: 10px;
}
</style>
